// Monitoring configuration - reads from environment variables
export const config = {
  monitoring: {
    mode: process.env.REACT_APP_BILLING_ALERTS_MODE || "TEST",
    slo: {
      p95Ms: Number(process.env.REACT_APP_BILLING_ALERTS_P95_MS || 2000),
    },
  },
  notifications: {
    configured:
      String(process.env.REACT_APP_NOTIFICATIONS_CONFIGURED || "false") ===
      "true",
  },
};

export const MODES = {
  TEST: "TEST",
  LIVE: "LIVE",
};
